import BaseValidator from "./base.validator";

/**
 * @author Jorge Perales
 * @description  Class to create the branch-office validators extending BaseValidator Class
 * @date 30-04-2025
 * @export
 * @class BranchOfficeValidator
 */
export default class BranchOfficeValidator extends BaseValidator {

    /**
     * @author Jorge Perales
     * @description Creates an instance of BranchOfficeValidator.
     * @date 30-04-2025
     * @param {*} t
     * @memberof BranchOfficeValidator
     */
    constructor(t) {
        super(t); // Calls the BaseValidator constructor (to initialize this.t and this.regexs)

        // Extends this.regexs with specific validations for BranchOfficeValidator
        //this.regexs.domain = /^((?!@)([a-z0-9._-]+\.)+[a-z0-9_-]{1,})$/ Example to use this functionality
    }

    /**
     * @author Jorge Perales
     * @description Get an object that contains all the branch-office validators to manipulate in the actions and views
     * @date 30-04-2025
     * @return {Object} Validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BranchOfficeValidator
     */
    getValidators() {
        return {
            // Reuses validators from the parent class
            textInput: (value, tClave) => this.validateText(value, tClave),
            nameInput: (value, tClave) => this.validateTextStrict(value, tClave),
            keyInput: (value, tClave) => this.validateText(value, tClave),
            numberInput: (value, tClave) => this.validateNumber(value, tClave)

            // Specific validator for domain
            //domainInput: (value) => this.regexs.domain.test(value) ? "" : this.t("configuration.administrate.textValidator.email"), Example to use this functionality
        };
    }
}